import React from 'react';
import { useAppState } from './hooks/useAppState';
import { useAuth } from './hooks/useAuth';
import { SplashScreen } from './components/SplashScreen';
import { AuthScreen } from './components/screens/AuthScreen';
import { BottomNav } from './components/BottomNav';
import { Modal } from './components/Modal';
import { Reader } from './components/Reader';
import { Toast } from './components/Toast';
import { HomeScreen } from './components/screens/HomeScreen';
import { ProgramScreen } from './components/screens/ProgramScreen';
import { LearnScreen } from './components/screens/LearnScreen';
import { ToolsScreen } from './components/screens/ToolsScreen';
import { TrackerScreen } from './components/screens/TrackerScreen';
export function App() {
  const {
    activeScreen,
    setActiveScreen,
    splashVisible,
    splashRendered,
    tasks,
    toggleTask,
    symptoms,
    setSymptom,
    activeModal,
    setActiveModal,
    activeChapter,
    setActiveChapter,
    toast,
    showToast
  } = useAppState();
  const {
    user,
    isAuthenticated,
    authMode,
    setAuthMode,
    login,
    signup
  } = useAuth();
  return <div className="relative w-full max-w-[430px] mx-auto min-h-screen bg-bg-main overflow-x-hidden font-sans" data-id="element-0">
      {splashRendered && <SplashScreen visible={splashVisible} userName={user?.firstName} data-id="element-1" />}
      {!splashVisible && !isAuthenticated && <AuthScreen authMode={authMode} setAuthMode={setAuthMode} onLogin={login} onSignup={signup} data-id="element-2" />}
      {!splashVisible && isAuthenticated && <>
          {activeScreen === 'home' && <HomeScreen userName={user?.firstName} tasks={tasks} toggleTask={toggleTask} openModal={setActiveModal} navTo={setActiveScreen} data-id="element-3" />}
          {activeScreen === 'program' && <ProgramScreen openModal={setActiveModal} data-id="element-4" />}
          {activeScreen === 'learn' && <LearnScreen openChapter={setActiveChapter} data-id="element-5" />}
          {activeScreen === 'tools' && <ToolsScreen openModal={setActiveModal} data-id="element-6" />}
          {activeScreen === 'tracker' && <TrackerScreen symptoms={symptoms} setSymptom={setSymptom} showToast={showToast} data-id="element-7" />}

          <BottomNav activeScreen={activeScreen} setActiveScreen={setActiveScreen} data-id="element-8" />
        </>}
      {isAuthenticated && <>
          <Modal activeModal={activeModal} closeModal={() => setActiveModal(null)} showToast={showToast} data-id="element-9" />
          <Reader activeChapter={activeChapter} closeReader={() => setActiveChapter(null)} showToast={showToast} data-id="element-10" />
        </>}
      <Toast message={toast} data-id="element-11" />
    </div>;
}